import React, { useState, useEffect } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  CircularProgress, // Import CircularProgress for the loader
} from "@mui/material";
import axiosInstance from "../axios_helper/axiosInstance";
import ImageModal from "../components/ImageModal";

export default function Product_table() {
  const [stockItems, setStockItems] = useState([]);
  const [open, setOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [imageError, setImageError] = useState(false);

  // State for managing loading
  const [loading, setLoading] = useState(true);

  // Fetch data from API
  useEffect(() => {
    fetchShop1Items();
  }, []);

  const fetchShop1Items = () => {
    axiosInstance
      .get("stock-items/?shop")
      .then((response) => {
        // Sort items by ID assuming higher ID means more recent
        const sortedItems = response.data.sort((a, b) => b.id - a.id);
        // Get the 7 most recent items
        const recentItems = sortedItems.slice(0, 6);
        setStockItems(recentItems);
        setLoading(false); // Set loading to false after data is fetched
      })
      .catch((error) => {
        console.error("Error fetching Shop items:", error);
        setLoading(false); // Even if there's an error, stop the loader
      });
  };

  const handleOpen = (imageUrl) => {
    setSelectedImage(imageUrl);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedImage(null);
  };

  const handleImageError = (id) => {
    setImageError(true);
  };

  return (
    <>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>No.</TableCell>
              <TableCell align="center">Code</TableCell>
              <TableCell align="center">N.wt</TableCell>
              <TableCell align="center">G.wt</TableCell>
              <TableCell align="center">Kundan</TableCell>
              <TableCell align="center">Moti</TableCell>
              <TableCell align="center">PO</TableCell>
              <TableCell align="center">PCS</TableCell>
              <TableCell align="center">Supplier</TableCell>
              <TableCell align="center">Category</TableCell>
              <TableCell align="center">Image</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {loading ? (
              <TableRow>
                <TableCell colSpan={11} align="center">
                <div className="table-loader">
                  <CircularProgress
                  size={30}
                  style={{ color: "#7451f8" }}
                  />
                </div>
                </TableCell>
              </TableRow>
            ) : (
              stockItems.length > 0 ? (
                stockItems.map((item, index) => (
                  <TableRow key={item.id}>
                    <TableCell component="th" scope="row">
                      {index + 1}
                    </TableCell>
                    <TableCell align="center">{item.code.toUpperCase()}</TableCell>
                    <TableCell align="center">{item.gw}</TableCell>
                    <TableCell align="center">{item.nw}</TableCell>
                    <TableCell align="center">{item.kundan}</TableCell>
                    <TableCell align="center">{item.moti}</TableCell>
                    <TableCell align="center">{item.po}</TableCell>
                    <TableCell align="center">{item.pcs}</TableCell>
                    <TableCell align="center">{item.supplier.toUpperCase()}</TableCell>
                    <TableCell align="center" style={{ textTransform: 'capitalize' }}>{item.category_name}</TableCell>
                    <TableCell align="center">
                      <img
                        className="table_image"
                        src={item.image}
                        alt={item.code}
                        width="40"
                        height="40"
                        style={{ cursor: "pointer", borderRadius: "50%" }}
                        onClick={() => handleOpen(item.image)}
                        onError={() => handleImageError(item.id)}
                      />
                      {imageError && <div>Image not available</div>}
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={11} align="center">
                    No items match your search
                  </TableCell>
                </TableRow>
              )
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <ImageModal open={open} handleClose={handleClose} imageUrl={selectedImage} />
    </>
  );
}
